export default {
    path: '/google/authorized',
    name: 'google-authorized',
    component: () => import('src/pages/auth/LoadingRedirectPage.vue'),
    meta: {
        title: 'HQZen',
        canDisplayGlobalModals: false
    },
};
